// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__1G_1T","content":"preview_content__2O1E1","preview":"preview_preview__sO9zO","mobileContainar":"preview_mobileContainar__ip0DK"};